module.exports = __webpack_public_path__ + "static/media/hotel-f6_bg_v2.59774dac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/hotel-f6_bg_v2.jpg
// module id = 321
// module chunks = 0